import script from "./IonicElement.vue?vue&type=script&setup=true&lang=ts"
export * from "./IonicElement.vue?vue&type=script&setup=true&lang=ts"

import "./IonicElement.vue?vue&type=style&index=0&id=e3024be4&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/livoapp/LivoFrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3024be4"]])

export default __exports__